import LandingPage from "../LandingPage.jsx";

export default function LandingNo() {
  return <LandingPage forcedLang="no" />;
}